import { ComponentPropsWithoutRef } from "react"
import { Label } from "@/components/chadcn/Label"
import { TextareaInput } from "@/components/InputFields"

type NotesFieldProps = {
  id?: string
  isError?: boolean
} & Omit<ComponentPropsWithoutRef<"textarea">, "id">

const NotesField = ({ id = "notes", isError, ...otherProps }: NotesFieldProps) => (
  <div className="flex flex-col gap-1">
    <Label htmlFor={id}>Notes (optional)</Label>
    <TextareaInput
      id={id}
      isError={isError}
      rows={3}
      placeholder="Any additional notes…"
      {...otherProps}
    />
  </div>
)

export default NotesField
